import React, { useState } from 'react';
import { LampOn } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useLocalStorage } from '@/hooks/use-local-storage';

interface TemplateUpsellModalProps {
    onClose: () => void;
}

export const TemplateUpsellModal: React.FC<TemplateUpsellModalProps> = ({ onClose }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setDontShowAgain] = useLocalStorage('template_upsell_dismissed', false);
    const [checked, setChecked] = useState(false);

    const handleConfirm = () => {
        if (checked) {
            setDontShowAgain(true);
        }
        onClose();
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="flex items-start gap-4">
                <div className="shrink-0 rounded-full bg-amber-100 p-3">
                    <LampOn className="size-6 text-amber-600" />
                </div>
                <div className="space-y-2">
                    <h3 className="text-lg font-semibold">Agilize seus laudos com Modelos!</h3>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                        Você sabia que pode salvar seus modelos de laudo para usar futuramente? Crie
                        estruturas personalizadas, textos padrão e configurações visuais para
                        economizar tempo em cada novo atendimento.
                    </p>
                </div>
            </div>

            <div className="mt-2 flex flex-col items-center justify-between gap-4 border-t pt-4 sm:flex-row">
                <div className="flex items-center space-x-2">
                    <Checkbox
                        id="dont-show"
                        checked={checked}
                        onCheckedChange={(c) => setChecked(c === true)}
                    />
                    <Label
                        htmlFor="dont-show"
                        className="cursor-pointer text-sm font-normal text-muted-foreground"
                    >
                        Não mostrar novamente
                    </Label>
                </div>
                <Button onClick={handleConfirm} className="w-full sm:w-auto">
                    Entendi
                </Button>
            </div>
        </div>
    );
};
